// Vendored from echoes-sh/guard packages/guard (@echoes/guard 0.1.0). Replace with the npm package once published.
import { dashClient, sentinelClient as infraSentinelClient } from "@better-auth/infra/client";
import type { SentinelClientOptions } from "@better-auth/infra/client";

export { dashClient };
export type { DashClientOptions, SentinelClientOptions } from "@better-auth/infra/client";
export { GUARD_DEFAULT_KV_URL, guardIdentifyUrl } from "./urls";

export type GuardSentinelClientOptions = SentinelClientOptions & {
  /** `guardIdentifyUrl(publicId, kvUrl)`, i.e. `{kv}/projects/{publicId}`. Required: the plugin's default is Better Auth's hosted KV. */
  identifyUrl: string;
};

/** Official `sentinelClient` with `identifyUrl` made mandatory. */
export function sentinelClient(options: GuardSentinelClientOptions): ReturnType<typeof infraSentinelClient> {
  if (!options?.identifyUrl) throw new Error("@echoes/guard/client: sentinelClient({ identifyUrl }) is required");
  return infraSentinelClient(options);
}
